var _path;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgAnchor(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 24,
    height: 24,
    viewBox: "0 0 24 24",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M9 6C9 7.30622 9.83481 8.41746 11 8.82929L11 16.874C9.27477 16.4299 8 14.8638 8 13L6 13C6 15.973 8.16229 18.441 11 18.917V20C11 20.5523 11.4477 21 12 21C12.5523 21 13 20.5523 13 20V18.917C15.8377 18.441 18 15.973 18 13H16C16 14.8638 14.7252 16.4299 13 16.874L13 8.82929C14.1652 8.41746 15 7.30622 15 6C15 4.34315 13.6569 3 12 3C10.3431 3 9 4.34315 9 6ZM12 7C11.4477 7 11 6.55228 11 6C11 5.44772 11.4477 5 12 5C12.5523 5 13 5.44772 13 6C13 6.55228 12.5523 7 12 7Z",
    fill: "#7E8A96"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgAnchor);
export default __webpack_public_path__ + "static/media/anchor.5d51f050.svg";
export { ForwardRef as ReactComponent };